import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BuscaCodigoAlumnoComponent } from './componentes/busca-codigo-alumno/busca-codigo-alumno.component';
import { FichaComponent } from './componentes/ficha/ficha.component';
import { GraciasComponent } from './componentes/gracias/gracias.component';
import { PerdidoComponent } from './componentes/perdido/perdido.component';

const routes: Routes = [
  { path: '', component: PerdidoComponent },
  { path: 'ficha/:codigoColegioEnviado', component: FichaComponent },
  { path: 'gracias', component: GraciasComponent },
  { path: '**', component: PerdidoComponent , pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollOffset: [0, 0], scrollPositionRestoration: 'top', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
